export default __webpack_public_path__ + "f3b6d60a6d77e5515618e2711dbd80f0.png";